(function () {
  'use strict';

  var STATE_KEY = '__mellowBenefitsNight';
  var state = window[STATE_KEY];
  if (!state) {
    state = { roots: new WeakSet(), listeners: false, domReadyBound: false };
    window[STATE_KEY] = state;
  }

  function setActive(dots, idx) {
    for (var i = 0; i < dots.length; i++) {
      var dot = dots[i];
      var dotIdx = parseInt(dot.getAttribute('data-benefits-dot'), 10);
      var isActive = dotIdx === idx;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    }
  }

  function computeActiveIndex(grid, items) {
    var scrollLeft = grid.scrollLeft;
    var viewportCenter = scrollLeft + grid.clientWidth / 2;
    var bestIdx = 0;
    var bestDist = Infinity;
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      var center = el.offsetLeft + el.offsetWidth / 2;
      var dist = Math.abs(center - viewportCenter);
      if (dist < bestDist) {
        bestDist = dist;
        bestIdx = i;
      }
    }
    return bestIdx;
  }

  function scrollToIndex(grid, items, idx) {
    var target = items[idx];
    if (!target) return;
    var paddingLeft = 0;
    var cs = window.getComputedStyle(grid);
    var pl = cs && cs.paddingLeft;
    if (pl) paddingLeft = parseFloat(pl) || 0;
    var left = target.offsetLeft - paddingLeft;
    if (left < 0) left = 0;
    if (typeof grid.scrollTo === 'function') {
      grid.scrollTo({ left: left, behavior: 'smooth' });
    } else {
      grid.scrollLeft = left;
    }
  }

  function setupRoot(root) {
    if (!root || root.nodeType !== 1) return;
    if (state.roots.has(root)) return;
    state.roots.add(root);

    var grid = root.querySelector('[data-benefits-grid]');
    var dotsWrap = root.querySelector('[data-benefits-dots]');
    if (!grid || !dotsWrap) return;

    var items = grid.querySelectorAll('[data-benefits-index]');
    var dots = dotsWrap.querySelectorAll('[data-benefits-dot]');
    if (!items.length || !dots.length) return;

    var rafId = 0;
    var lastIdx = -1;

    function update() {
      rafId = 0;
      var idx = computeActiveIndex(grid, items);
      if (idx !== lastIdx) {
        lastIdx = idx;
        setActive(dots, idx);
      }
    }

    function onScroll() {
      if (rafId) return;
      rafId = window.requestAnimationFrame(update);
    }

    grid.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    for (var i = 0; i < dots.length; i++) {
      (function (dot) {
        dot.addEventListener('click', function () {
          var idx = parseInt(dot.getAttribute('data-benefits-dot'), 10);
          if (isNaN(idx)) return;
          scrollToIndex(grid, items, idx);
        });
      })(dots[i]);
    }

    update();
  }

  function scanDocument() {
    var roots = document.querySelectorAll('[data-benefits-root]');
    for (var i = 0; i < roots.length; i++) {
      setupRoot(roots[i]);
    }
  }

  function onSectionLoad(ev) {
    var t = ev && ev.target;
    if (!t || typeof t.querySelectorAll !== 'function') return;
    var inner = t.querySelectorAll('[data-benefits-root]');
    for (var j = 0; j < inner.length; j++) {
      setupRoot(inner[j]);
    }
  }

  function bindSectionListener() {
    if (state.listeners) return;
    state.listeners = true;
    document.addEventListener('shopify:section:load', onSectionLoad);
  }

  function init() {
    scanDocument();
    bindSectionListener();
  }

  if (state.domReadyBound) {
    init();
    return;
  }

  if (document.readyState === 'loading') {
    state.domReadyBound = true;
    document.addEventListener('DOMContentLoaded', init);
  } else {
    state.domReadyBound = true;
    init();
  }
})();
